<template>
  <div>
    <div
      id="storeInfo"
      :class="[border ? '' : 'boxBorder']"
      :style="border ? border : {}"
      v-if="!hideStore"
    >
      <div class="title">
        <i class="el-icon-s-shop"></i>
        <span class="titleName">{{ storeName }}</span>
      </div>
      <div class="desc">
        <div class="descTitle">
          <i class="el-icon-medal"></i>
          <span class="descTitleText"
            >{{ companyInfo && formateGrade(companyInfo.s_grade) }}级店铺</span
          >
        </div>
      </div>
      <div class="descContent">
        <div class="descContentItem">
          <div class="descContentItemText">描 述</div>
          <div class="descContentItemNum">
            {{ goodsAvgScore ? goodsAvgScore + ".0" : "-" }}
          </div>
        </div>
        <div class="descContentItem">
          <div class="descContentItemText">服 务</div>
          <div class="descContentItemNum">
            {{ serviceAvgScore ? serviceAvgScore + ".0" : "-" }}
          </div>
        </div>
        <div class="descContentItem">
          <div class="descContentItemText">物 流</div>
          <div class="descContentItemNum">
            {{ timeAvScore ? timeAvScore + ".0" : "-" }}
          </div>
        </div>
      </div>
      <div class="contentButtonBox">
        <div class="contentButtonItem">
          <span @click="toStoreHomePage" class="contentButtonItemText hoverText"
            >进店逛逛</span
          >
        </div>
        <!-- <div class="contentButtonItem">
        <span class="contentButtonItemText">收藏店铺</span>
      </div> -->
      </div>
    </div>
    <div>
      <div  class="info">- 推荐商品 -</div>
      <div class="goodsBox">
        <div
          v-for="(item, index) in allGoodsList"
          @click="() => toGoodsDetail(item)"
          :key="index"
          class="goodsItem"
        >
          <el-image
            style="width: 70px; height: 70px"
            :src="getImageUrl(item.coverPlan)"
            fit="cover"
          ></el-image>
          <div class="goodsName">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getDate,
  getCity,
  queryCompanyGetUrl,
  getImageUrl,
  queryAllGoodsList,
} from "@/api/api";
import { mapState } from "vuex";
export default {
  props: ["storeName", "border", "storeId",'hideStore','num'],
  data() {
    return {
      companyInfo: null,
      goodsAvgScore: "1",
      serviceAvgScore: "1",
      timeAvScore: "1",
      allGoodsList: null,
    };
  },
  watch: {
    "$route.query": function () {
      this.getCompanyMsg();
      this.initGoodsListData();
    },
  },
  mounted() {
    this.getCompanyMsg();
    this.initGoodsListData();
    this.getImageUrl = getImageUrl;
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    toGoodsDetail(item) {
      this.$router.push({
        name: "goodsDetail",
        query: { goodsId: item.id, type: -1 },
      });
    },
    initGoodsListData() {
      let that = this;
      let url = queryAllGoodsList;
      let data = {
        pageIndex: parseInt(Math.random() * 10) + parseInt(Math.random() * 10),
        pageSize: this.num?this.num:4,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          console.log(res);
          if (res.data.resultCode == 1) {
            const { data } = res.data;
            that.allGoodsList = JSON.parse(JSON.stringify(data));
          } else {
            this.$alert(res.data.resultMsg)
          }
        })
        .catch((err) => {
          this.$alert(JSON.stringify(err))
        });
    },
    toStoreHomePage() {
      this.$router.push({
        name: "storeHomePage",
        query: { store_id: this.storeId },
      });
    },
    formateGrade(grade) {
      switch (grade) {
        case "1":
          return "一";
        case "2":
          return "二";
        case "3":
          return "三";
        case "4":
          return "四";
        case "5":
          return "五";
      }
      return "一";
    },
    getCompanyMsg() {
      let that = this;
      let data = {
        storeId: this.storeId,
      };
      // alert(this.storeId)
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({ method: "post", data: param, url: queryCompanyGetUrl })
        .then((res) => {
          console.log("公司信息1", res);
          if (res.data.resultCode == 1) {
            console.log("res.data1", res.data.data);
            let { data } = res.data;
            let { company } = data;
            this.companyInfo = company;

            this.goodsAvgScore = res.data.data.goodsAvgScore;
            this.serviceAvgScore = res.data.data.serviceAvgScore;
            this.timeAvScore = res.data.data.timeAvScore;
          } else {

          }
        })
        .catch((err)=> {
         this.$alert(JSON.stringify(err))
        });
    },
  },
};
</script>

<style lang='less' scoped>
.boxBorder {
  border: 1px solid red;
}
#storeInfo {
  padding: 10px 0;
  background-color: #fff;
  color: #666;
  font-size: 14px;
  width: 280px;
  .title {
    font-size: 14px;
    text-align: center;
    height: 50px;
    // background-color: blue;
    line-height: 50px;
    border-bottom: 1px solid #eee;
    color: #333;
  }
  .desc {
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
  .descContent {
    display: flex;
    justify-content: space-around;
    text-align: center;
    font-size: 14px;
  }
  .contentButtonBox {
    display: flex;
    justify-content: space-around;
    font-size: 10px;
    margin: 15px 0 10px 0;
  }
  .contentButtonItem {
    background-color: #fff;
    width: 66px;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #ccc;
  }
  .contentButtonItem:hover {
    cursor: pointer;
  }
  .descContentItemNum {
    margin-top: 5px;
    font-size: 13px;
    color: #f60;
  }
  .descContentItemText {
    font-size: 13px;
    color: #454545;
  }
}
.goodsItem {
  background-color: #fff;
  margin: 10px;
  margin-top: 0px;
  margin-bottom: 10px;
  font-size: 13px;
  color: #454545;
  padding: 10px;
  width: 90px;
  height: 80px;
  text-align: center;
}
.goodsItem {
  cursor: pointer;
}
.goodsName {
  margin-top: 5px;
  max-height: 40px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 12px;
  color:#454545
}
.goodsBottomBox {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.buyBtn {
  width: 40px;
  height: 20px;
  background-color: #f60;
  color: #fff;
  text-align: center;
  line-height: 20px;
  font-size: 13px;
}
.buyBtn:hover {
  cursor: pointer;
}
.storeInfoTilteRight {
  font-size: 13px;
  color: #f60;
}
.el-icon-star-on {
  color: #888;
  font-size: 15px;
  line-height: 15px;
}
.iconText {
  margin-left: 3px;
  font-size: 13px;
  line-height: 15px;
}
.goodsBox {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-left:10px;
  padding-right: 10px;
}
.info {
  color: #777;
  font-size: 13px;
  text-align: center;
  margin: 10px;
}
.titleName {
  text-overflow: ellipsis;
  font-size: 13px;
  color: #595959;
  white-space: nowrap;
  overflow: hidden;
}
.descTitleText {
  font-size: 13px;
  color: #454545;
}
.contentButtonItemText {
  color: #454545;
  font-size: 12px;
}
.goodsItem:hover .goodsName{
  color:red
}
.el-icon-s-shop{
  color:#595959
}
.el-icon-medal{
  color:#409EFF;

}
</style>



// WEBPACK FOOTER //
// src/components/components/StoreInfo.vue